<template>
	<div>
		<b-row class="justify-content-lg-center">
			<b-col :lg="6">
                <b-card>
                    <div v-for="(button, index) in navButtons" :key="index" class="mb-2">
                        <b-button variant="outline-primary" :href="button.url" size="lg" block>
                            {{ button.label }} <b-icon icon="arrow-right-short" shift-v="1"/>
                        </b-button>
                    </div>
                </b-card>
			</b-col>
			<b-col />
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'HomeIndex',
    props: ['user', 'checkRole'],
    data() {
        return {
            navButtons: this.checkRole(this.user, 'ROLE_ADMIN') ? [
                // admin
                { label: this.$t('home_nav_button_task_new'), url: '/task/new' },
                { label: this.$t('home_nav_button_task'), url: '/task' },
                { label: this.$t('home_nav_button_invoice'), url: '/invoice' },
                { label: this.$t('home_nav_button_worker'), url: '/worker' },
                { label: this.$t('home_nav_button_customer'), url: '/customer' },
                { label: this.$t('home_nav_button_product'), url: '/product' },
                { label: this.$t('home_nav_button_report'), url: '/report' },
            ] : [
                // user
                { label: this.$t('home_nav_button_task_new'), url: '/task/new' },
                { label: this.$t('home_nav_button_task'), url: '/task' },
                { label: this.$t('home_nav_button_customer'), url: '/customer' },
                { label: this.$t('home_nav_button_product'), url: '/product' },
            ]
        }
    },
}
</script>
